//import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IBodyPart, ISizeModel, ISizeModelMeasure } from "../types";
import { E_BodyPart } from "../../common/types";
import "./SizesForm.css";
import { FormattedMessage } from "react-intl";

interface SizesFormProps {
  ValidateSizes: () => boolean;
  showCustomWarning: boolean;
}

const SizesForm = (props: any) => {
  const createNewRowSize = (indice: number) => {
    let newSize: ISizeModel;
    let nextOrder: number = indice;

    try {
      if (indice > 0) {
        const currentElements = [...props.Elements];

        nextOrder = currentElements[currentElements.length - 1].Order;
      }

      newSize = {
        Id: indice,
        Order: nextOrder + 1,
        Name: "",
        Measures: new Array<ISizeModelMeasure>(),
      };

      props.BodyParts.forEach((item: IBodyPart, indexBodyPart: number) => {
        let RowMeasure: ISizeModelMeasure = {
          Id: 0,
          From: 0,
          ErrorFrom: false,
          To: 0,
          ErrorTo: false,
          IsSuccess: false,
          BodyPart: item,
        };
        newSize.Measures.push(RowMeasure);
      });

      return newSize;
    } catch (error) {
      console.log(error);
    }

    return undefined;
  };

  const onSizeNameChange = (index: number, value: string, item: ISizeModel) => {
    const newSizes = [...props.Elements];
    const currentSize = newSizes[index];

    currentSize.Name = value ? value.toUpperCase() : "";

    if (props.SucribeChanges) props.SucribeChanges(newSizes);
  };

  const onSizeMesaureChangeFrom = (
    index: number,
    referenceId: number,
    value: number,
    item: ISizeModelMeasure
  ) => {
    const newSizes = [...props.Elements];
    const currentSize = newSizes[index];
    const currentSizeMesure = currentSize.Measures[referenceId];

    currentSizeMesure.From = value;

    if (newSizes && newSizes.length > 0) {
      const lastSize = newSizes[index - 1];

      if (lastSize) {
        const lastSizeMeasure = lastSize.Measures[referenceId];

        if (lastSizeMeasure.To > (currentSizeMesure.From || 0)) {
          currentSizeMesure.ErrorFrom = true;
        } else {
          currentSizeMesure.ErrorFrom = false;
        }
      }
    }

    if (
      !currentSizeMesure.ErrorFrom &&
      !currentSizeMesure.ErrorTo &&
      currentSizeMesure.From < (currentSizeMesure.To || 0)
    ) {
      currentSizeMesure.IsSuccess = true;
    }

    if (props.SucribeChanges) props.SucribeChanges(newSizes);
  };

  const onSizeMesaureChangeTo = (
    index: number,
    referenceId: number,
    value: number,
    item: ISizeModelMeasure
  ) => {
    const newSizes = [...props.Elements];
    const currentSize = newSizes[index];
    const currentSizeMesure = currentSize.Measures[referenceId];

    if (item.BodyPart?.Id === E_BodyPart.FOOT) {
      if (newSizes[index - 1]) {
        currentSizeMesure.From =
          newSizes[index - 1].Measures[referenceId].To + 0.01;
      } else {
        currentSizeMesure.From = value - 0.4;
      }
    }

    currentSizeMesure.To = value;

    if (currentSizeMesure.From >= currentSizeMesure.To) {
      currentSizeMesure.ErrorTo = true;
    } else {
      currentSizeMesure.ErrorTo = false;
    }

    if (
      !currentSizeMesure.ErrorFrom &&
      !currentSizeMesure.ErrorTo &&
      currentSizeMesure.From < currentSizeMesure.To
    ) {
      currentSizeMesure.IsSuccess = true;
    }

    if (props.SucribeChanges) props.SucribeChanges(newSizes);
  };

  const onSizeRemove = (index: number, item: ISizeModel) => {
    if (index > 0) {
      const newSizes = [...props.Elements];
      newSizes.splice(index, 1);

      if (props.SucribeChanges) props.SucribeChanges(newSizes);
    }
  };

  const onSizeAdd = () => {
    const newSizes = [...props.Elements];
    const newSize = createNewRowSize(newSizes.length);

    if (newSize) {
      newSizes.push(newSize);
      if (props.SucribeChanges) props.SucribeChanges(newSizes);
    }
  };

  const areHaveErrors = () => {
    let counterErrors: number = 0;

    try {
      const newSizes = [...props.Elements];

      if (newSizes && newSizes.length > 0) {
        const sizesErrors = newSizes.filter((item: ISizeModel) => {
          const sizeMeasuresErrors = item.Measures.filter(
            (itemMeasure: ISizeModelMeasure) => {
              return itemMeasure.ErrorFrom || itemMeasure.ErrorTo;
            }
          );

          return sizeMeasuresErrors && sizeMeasuresErrors.length > 0;
        });

        counterErrors = sizesErrors?.length || 0;
      }
    } catch (error) {
      console.log("SIZES FORM ERROR", error);
    }

    return counterErrors === 0;
  };

  return (
    <>
      <Row className="mb-2">
        <Col xs={2}>
          <p className="font-fitprenda-size-block-title">
            <FormattedMessage id="ready-size-sizes" defaultMessage="Talles" />
          </p>
        </Col>
        {props.BodyParts.map((elemento: IBodyPart, indice: number) => {
          return (
            <Col
              key={`column-size-${elemento.Id}`}
              xs={props.BodyParts.length > 2 ? 2 : 3}
              className="text-center"
            >
              <p
                className={`font-fitprenda-size-block-title ${
                  props.BodyParts.length > 2 ? "" : "ps-5"
                }`}
              >
                {elemento.Name}
              </p>
            </Col>
          );
        })}
      </Row>

      <Form>
        {props.Elements.map((elemento: ISizeModel, indice: number) => {
          return (
            <>
              <Row className="mb-2" key={`row-size-${elemento.Id}`}>
                <Col xs={2}>
                  <Row className="justify-content-start">
                    <Col xs={7} className="size-form-input-sizes">
                      <Form.Control
                        type="text"
                        size="sm"
                        className="text-center text-uppercase"
                        defaultValue={elemento.Name}
                        onChange={(e) =>
                          onSizeNameChange(
                            indice,
                            e.target.value ? e.target.value : "",
                            elemento
                          )
                        }
                      />
                    </Col>
                  </Row>
                </Col>
                {elemento.Measures.map(
                  (
                    elementoMeasure: ISizeModelMeasure,
                    indiceMeasure: number
                  ) => {
                    return (
                      <>
                        <Col
                          xs={1}
                          className={`${
                            props.BodyParts.length > 2 ? "d-none" : "d-block"
                          }`}
                        ></Col>
                        {/* EL PRIMER INPUT */}
                        <Col xs={2} key={`row-col-size`}>
                          <Row className="justify-content-center">
                            <Col
                              xs={4}
                              className="px-0 size-form-input-container"
                            >
                              {elementoMeasure.BodyPart?.Id ===
                              E_BodyPart.FOOT ? null : ( // Render nothing for FOOT
                                // Render the input for other body parts
                                <Form.Control
                                  type="text"
                                  size="sm"
                                  className="text-center text-uppercase"
                                  isInvalid={elementoMeasure.ErrorFrom}
                                  defaultValue={elementoMeasure.From}
                                  onChange={(e) =>
                                    onSizeMesaureChangeFrom(
                                      indice,
                                      indiceMeasure,
                                      e.target.value
                                        ? parseFloat(e.target.value)
                                        : 0,
                                      elementoMeasure
                                    )
                                  }
                                />
                              )}
                            </Col>
                            <Col xs={1} className="px-0 text-center">
                              {elementoMeasure.BodyPart?.Id ===
                              E_BodyPart.FOOT ? null : (
                                <p className="font-fitprenda-size-block-title">
                                  -
                                </p>
                              )}
                            </Col>
                            <Col
                              xs={4}
                              className="px-0 size-form-input-container"
                            >
                              <Form.Control
                                type="text"
                                size="sm"
                                className="text-center text-uppercase"
                                isInvalid={elementoMeasure.ErrorTo}
                                defaultValue={elementoMeasure.To}
                                onChange={(e) =>
                                  onSizeMesaureChangeTo(
                                    indice,
                                    indiceMeasure,
                                    e.target.value
                                      ? parseFloat(e.target.value)
                                      : 0,
                                    elementoMeasure
                                  )
                                }
                              />
                            </Col>
                            <Col xs={1}>
                              {elementoMeasure.ErrorFrom ||
                              elementoMeasure.ErrorTo ? (
                                <FontAwesomeIcon
                                  icon={"exclamation-triangle"}
                                  className="text-fitprenda-danger"
                                />
                              ) : elementoMeasure.IsSuccess ? (
                                <FontAwesomeIcon
                                  icon={"check-circle"}
                                  className="text-fitprenda-success"
                                />
                              ) : (
                                <></>
                              )}
                            </Col>
                          </Row>
                        </Col>
                      </>
                    );
                  }
                )}
                <Col className="text-center" xs={1}>
                  <span
                    className="btn-sizeguide-form"
                    style={{ borderRadius: "10px", padding: "1px" }}
                  >
                    <FontAwesomeIcon
                      onClick={(e) => onSizeRemove(indice, elemento)}
                      icon={"times"}
                      className="text-secondary"
                    />
                  </span>
                </Col>
              </Row>
            </>
          );
        })}
      </Form>

      <Row className="mt-3">
        <Col>
          <span className="btn-sizeguide-form" onClick={() => onSizeAdd()}>
            <FontAwesomeIcon icon={"plus"} className="text-fitprenda-warning" />
            <span className="font-fitprenda-button-add-size ms-2">
              {" "}
              <FormattedMessage
                id="sizesform-add-sizes"
                // defaultMessage="Añadir talles"
              />
            </span>
          </span>
        </Col>
        <Col className="text-end">
          {!areHaveErrors() ? (
            <>
              <FontAwesomeIcon
                icon={"exclamation-triangle"}
                className="text-fitprenda-danger"
              />
              <span className="font-fitprenda-exclamation-size-guide ms-2">
                <FormattedMessage
                  id="sizesform-match-previous"
                  // defaultMessage="Este valor debe coincidir con la medida final del talle anteriors"
                />
              </span>
            </>
          ) : (
            <></>
          )}
          {props.showCustomWarning && (
            <Row className="mt-3">
              <Col>
                <FontAwesomeIcon
                  icon={"exclamation-triangle"}
                  className="text-fitprenda-danger"
                />
                <span className="font-fitprenda-custom-warning ms-2">
                  <FormattedMessage
                    id="sizesform-atleast"
                    // defaultMessage="Debe haber al menos 2 talles."
                  />
                </span>
              </Col>
            </Row>
          )}
        </Col>
      </Row>
    </>
  );
};

export default SizesForm;
